import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { ViewLeadPopupComponent } from '../../view-lead-popup/view-lead-popup.component';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { statuses } from 'src/app/common/events/status.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-interested-leads',
  templateUrl: './interested-leads.component.html',
  styleUrls: ['./interested-leads.component.css']
})
export class InterestedLeadsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  filters = {
    type: '',
    search: '',
    staffName: '0',
    status: '0',
    category: '0'
  };
  hoveredLead: any = null;
  

  pageSize = 10;
  pageIndex = 0;
  showdiv:boolean=false;
  hovered: any = null;

  totalRecords = 0;
  paginatedRecords = [];
  searchText: string = ''
  mainModules: any;
  expandedRow: number | null = null;
  expandedIndex: number | null = null;
  childData: any;
  editIndexRem: number | null = null;
  editRowValues: { [rowIndex: number]: { status: string, remarks: string } } = {};
  editIndex: number | null = null;
  saveAttempted = false;
  staffName: string = '0'
  statusList: any = statuses
  type: any;
  allStaffRecords: any;
  serviceType: string = '';
  categoryList: any
  selectedServiceType: string = '';
  statusType: string = 'interested';
  status: number = 0;
  userTypeName: string = '';
  leads: Array<any> = []
  assignedStaff: string = ''
  actualRemarks = [];
  realestateRemarks = [
    "Site Visit done",
    "Negotiation stage",
    "Discussion Stage",
    "Soft Approval Received",
    "Contract & Details sent"
  ]
  fintechRemarks = [
    "Application Filed",
    "Credit Check Completed",
    "Customer Docs Received",
    "Application Filed",
    "Credit Check Completed"
  ]
  propServicesRemarks = [
    "Site Visit Done",
    "Proposal Shared",
    "Negotiation Stage",
    "Catelouge Shared",
    "Models Finalised"
  ]
  constructor(private modalService: NgbModal,
    private rsbService: RsbService,
    public lookupModel: RsbLookupModel,
    private router: Router,
    private toast: ToastrService
  ) { }

  ngOnInit(): void {

    this.serviceType = this.lookupModel.getSelectedServiceType() ? this.lookupModel.getSelectedServiceType() : 'realEstate';
    this.type = this.lookupModel.getLoggedUser().type ? this.lookupModel.getLoggedUser().type : 'subFranchise'
    this.selectedServiceType = this.serviceType
    this.typeServices(0, this.serviceType)
    this.assignedStaff = 'myself'
    this.getStaff()
    this.getAllMainModules()

  }

  applyFilters(): void {
    this.typeServices(this.status, this.serviceType)
  }
  getAllMainModules(): void {
    this.rsbService.getAllMainModules({}).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.mainModules = rsp.contents
      }
    })
  }
  showAlert(leadRec: any) {
    this.showdiv=true;
  alert("Hovered on property image: " + this.generateTitle(leadRec));
}


  redirectUrl(data: any): void {
    let url = '';
    switch (data.moduleName.toUpperCase()) {
      case 'RENT':
      case 'BUY':
        url =
          'https://pillarblocks.com/property-details/' +
          encodeURIComponent(data.propertyTitle.replaceAll(' ', '-')) +
          '?listingId=' + data.propertyId +
          '&cat=' + data.categoryId +
          '&subcat=' + data.subCategoryId +
          '&module=' + data.moduleId +
          '&country=hCDjcS' +
          '&city=' + encodeURIComponent(data.city) +
          '&area=' + encodeURIComponent(data.area) +
          '&pincode=' + data.pincode;
        break;

      case 'PROJECTS':
        url =
          'https://pillarblocks.com/project-description/' +
          encodeURIComponent(data.projectName) +
          '?projectId=' + data.projectId +
          '&cat=' + data.categoryId +
          '&subcat=' + data.subCategoryId +
          '&country=hCDjcS' +
          '&city=' + encodeURIComponent(data.city) +
          '&area=' + encodeURIComponent(data.area) +
          '&pincode=' + data.pincode;
        break;
      case 'Plot & Land':
        url = 'https://pillarblocks.com/'
      case 'PG / HOSTELS':
      // url = 'https://pillarblocks.com/'
      case 'COMMERCIAL':
        // TODO: Build URLs for these modules if needed
        break;
    }
    if (url) {
      window.open(url, '_blank'); // open in new tab
    }
  }



  saveRowValues(leadRec: any, rowIndex: number, statusCtrl: any, remarksCtrl: any) {
    if (statusCtrl.invalid || remarksCtrl.invalid) {
      console.warn(`Invalid data for row ${rowIndex}`);
      return;
    }

    // Commit both fields
    leadRec.status = this.editRowValues[rowIndex].status;
    leadRec.remarks = this.editRowValues[rowIndex].remarks;

    console.log(`Saved row ${rowIndex}:`, this.editRowValues[rowIndex]);
    this.editIndex = null;
  }

  closeEdit(index: number) {
    this.editIndex = null
    this.saveAttempted = false;
    delete this.editRowValues[index];
  }

  startEditingRow(index: number) {
    this.editIndex = index;
    this.saveAttempted = false;
    this.editRowValues[index] = { status: '0', remarks: '' }; // default status = "0"
  }
  changeStatus(event: any) {
    this.status = event.target.value
    this.typeServices(0, this.serviceType)
  }
  selectStaff(event) {
    if (event.target.value! == '0') {
      this.filters.type = this.lookupModel.getLoggedUser().type === 'franchise' ? 'staff' : 'substaff'
    } else {
      this.filters.type = ''
    }
  }
  saveRemark(lead: any, index: number) {
    const rowValues = this.editRowValues[index];
    const remarks = rowValues.remarks.trim();
    if (Number(rowValues.status) === 0 || remarks.length < 5) {
      this.saveAttempted = true;
      this.toast.warning('Select a status and enter at least 5 characters for remarks.');
      return;
    }

    this.saveAttempted = false;
    const status = Number(rowValues.status);
    if (status === 5 || status === 9) {
      this.viewStatus(lead, status, remarks);
      return;
    }

    this.rsbService.addFranchiseLogs({ status, leadId: lead.leadId, franchiseId: lead.franchiseId, remarks }).subscribe({
      next: (rsp) => {
        if (rsp.statusCode === 0) {
          this.toast.success('Lead updated successfully.');
          this.editIndex = null;
          delete this.editRowValues[index];
          this.typeServices(0, this.serviceType);
        } else {
          this.toast.error('Unable to update this lead. Please try again.');
        }
      },
      error: () => {
        this.toast.error('Unable to update this lead. Please try again.');
      }
    });
  }

  saveRemarks(lead) {
    // Save logic (API call or local update)
    this.editIndexRem = null; // Exit edit mode
    this.rsbService.addFranchiseLogs({ status: lead.status, leadId: lead.leadId, franchiseId: lead.franchiseId, remarks: lead.remarks }).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        if (lead.status === 9) {
          this.router.navigate(['organizedLeads'])
        } else {
          this.typeServices(0, this.serviceType)
        }
      }
    })

  }

  getStatusName(value: number): string {
    const status = this.statusList.find(s => s.value === value);
    return status ? status.name : '';
  }


  getStaff(): void {
    this.rsbService.getStaffDataWithoutPagination().subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.allStaffRecords = rsp.contents
      }
    })
  }
  getLeads(type: string): void {
    this.statusType = type;
    this.typeServices(this.status, this.serviceType)

  }

  updatePaginatedRecords() {
    this.paginatedRecords = this.leads;
  }
  typeServices(status: number, serType: string): void {

    this.serviceType = serType;
    if (serType === 'realEstate') {
      this.actualRemarks = this.realestateRemarks
      this.rsbService.getAssignedFranchiseLeadsForFranchise({ "status": status }, this.serviceType, this.filters, this.pageSize, this.pageIndex).subscribe((rsp) => {
        if (rsp?.statusCode === 0 && rsp.contents.items?.length) {
          this.leads = rsp.contents.items;
          this.totalRecords = rsp.contents.total;
          this.updatePaginatedRecords()
        } else {
          this.leads = []
        }
      });
    } else if (serType === 'finTech') {
      this.actualRemarks = this.fintechRemarks
      this.rsbService.getAssignedFintechLeadsForFranchise({ "status": status }).subscribe((rsp) => {
        if (rsp?.statusCode === 0 && rsp.contents.length) {
          this.leads = rsp.contents;
        } else {
          this.leads = []
        }
      });
    } else if (serType === 'propService') {
      this.actualRemarks = this.propServicesRemarks
      this.rsbService.getAssignedPropServiceLeadsForFranchise({ "status": status }).subscribe((rsp) => {
        if (rsp?.statusCode === 0 && rsp.contents.length) {
          this.leads = rsp.contents;
        } else {
          this.leads = []
        }
      });
    } else {
      alert('Something went wrong');
    }
  }

  clearSearch() {
    this.filters.search = '';
    this.applyFilters()
  }

  resetFilters() {
    this.filters = {
      type: '',
      search: '',
      staffName: '',
      status: '0',
      category: '0'
    };
    this.applyFilters()
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Verified Lead':
        return 'status-verified';
      case 'Qualified Lead':
        return 'status-qualified';
      default:
        return 'status-default';
    }
  }

  getLeadTypeClass(type: string): string {
    switch (type) {
      case 'Online':
      case 'online':
        return 'lead-online';
      case 'Walkin':
        return 'lead-walkin';
      case 'Referral':
        return 'lead-referral';
      default:
        return 'lead-default';
    }
  }

  getCategoryClass(category: string): string {
    switch (category) {
      case 'Sale':
        return 'category-sale';
      case 'Rent':
        return 'category-rent';
      case 'Loans':
      case 'loans':
        return 'cat-loan';
      case 'Housing':
        return 'category-housing';
      case 'creditCard':
        return 'cat-credit-card'
      default:
        return 'category-default';
    }
  }

  getProductClass(product: string): string {
    switch (product) {
      case 'Villa':
        return 'product-villa';
      case 'Apartment':
        return 'product-apartment';
      case 'Land':
        return 'product-land';
      case 'Flat':
        return 'product-flat';
      case 'Plot':
        return 'product-plot';
      case 'Housing':
        return 'product-housing'; // Add this line
      case 'eduloan':
      case 'Edu Loan':
        return 'product-edu-loan'; // Add this line
      case 'Home Loan':
        return 'home-loan';
      case 'LAP':
        return 'laploan'; // Add this line
      case 'Personal/Self':
        return 'personalloan'; // Add this line
      case 'CCTV':
        return 'cctv'; // Add this line
      case 'Interior':
        return 'interior'; // Add this line
      case 'Furniture':
        return 'furniture'; // Add this line
      case 'Packers And Movers':
        return 'packers'; // Add this line

      default:
        return 'product-default';
    }
  }
  selectService(service: string) {
    this.selectedServiceType = service;
    this.serviceType = service;
    this.lookupModel.setSelectedServiceType(this.serviceType);
    //this.typeServices(this.lookupModel.getLoggedUser().type, service);
    this.typeServices(this.status, service);
  }

  assignedFunctionStaff(service: string) {
    this.assignedStaff = service
  }

  viewStatus(leads: any, status: number, remarks: string): void {
    const modalRef = this.modalService.open(ViewLeadPopupComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.statusSelected = status
    modalRef.componentInstance.remarks = remarks
    modalRef.result.then((result) => {
      let payload = {}
      result.status = Number(result.status);
      if (Number(result.status) === 5) {
        payload = {
          id: this.lookupModel.getLoggedUser().franchiseId,
          status: result.status,
          leadId: leads.leadId,
          date: result.date,
          description: result.remarks,
          propType: this.serviceType,
        }
        this.rsbService.addFollowup(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.toast.success('Lead Successfully updated to Followup');
            this.followupRedirectedMethod(result)
          }
        })

      } else if (Number(result.status === 9)) {
        payload = {
          franchiseId: this.lookupModel.getLoggedUser().franchiseId,
          status: result.status,
          opportunityStatus: result.opportunityStatus,
          leadId: leads.leadId,
          date:result.date,
          remarks: result.remarks,
          propType: this.serviceType
        }
        this.rsbService.addOppFranchiseLogs(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.toast.success('Lead Successfully updated to Followup');
            this.router.navigate(['organizedLeads'])
          }
        })
      } else {
        payload = {
          leadId: leads.leadId,
          status: result.status,
          description: result.remarks,
        }
      }
      if (this.serviceType === 'realEstate') {
        this.rsbService.updateLeadStatusForRealEstate(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.redirectMethod(result)
          }
        })

      } else if (this.serviceType === 'finTech') {
        this.rsbService.updateLeadStatusForFintech(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.redirectMethod(result)
          }
        })

      } else if (this.serviceType === 'propServices') {
        this.rsbService.updateLeadStatusForPropServices(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.redirectMethod(result)
          }
        })

      }

    })
  }

  view(leads: any): void {
    const modalRef = this.modalService.open(ViewLeadPopupComponent);
    modalRef.componentInstance.leadStatus = leads.status
    modalRef.componentInstance.statusSelected = leads.status
    modalRef.componentInstance.remarks = leads.remarks
    modalRef.result.then((result) => {
      let payload = {}
      result.status = Number(result.status);
      if (result.status === 5) {
        payload = {
          id: this.lookupModel.getLoggedUser().franchiseId,
          status: result.status,
          leadId: leads.leadId,
          date: result.date,
          description: result.remarks,
          propType: this.serviceType
        }
        this.rsbService.addFollowup(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.toast.success('Lead Successfully updated to Followup');
            this.followupRedirectedMethod(result)
          }
        })

      } else {
        payload = {
          leadId: leads.leadId,
          status: result.status,
          description: result.remarks,
        }
      }
      if (this.serviceType === 'realEstate') {
        this.rsbService.updateLeadStatusForRealEstate(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.redirectMethod(result)
          }
        })

      } else if (this.serviceType === 'finTech') {
        this.rsbService.updateLeadStatusForFintech(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.redirectMethod(result)
          }
        })

      } else if (this.serviceType === 'propServices') {
        this.rsbService.updateLeadStatusForPropServices(payload).subscribe((rsp) => {
          if (rsp.statusCode === 0) {
            this.redirectMethod(result)
          }
        })

      }

    })
  }

  generateTitle(leadRec) {
    switch (leadRec.product) {
      case 'Villa':
      case 'Apartment':
      case 'Independent House':
      case 'Flat': {
        const att = this.checkAttributes(leadRec.attributes || []); // assuming this is a method that processes Attr
        if (att) {
          return `${att} ${leadRec.product}`;
        } else {
          return leadRec.product
        }
      }
      case 'Plot':
      case 'Land': {
        const size = leadRec.measurementName ? `${leadRec.measurementName} ` : '';
        return `${leadRec.propertySize} ${size} ${leadRec.product}`;
      }
      default:
        return leadRec.product || 'Unknown Property';
    }
  }

  checkAttributes(attributes: []): string {
    let attributesRes: any = {}
    if (attributes.length) {
      attributesRes = attributes.find((obj: any) => {
        return obj.attributeName.toUpperCase() === "BHK"
      })
    }
    let res = ''
    if (Object.values(attributesRes).length > 0) {
      res = attributesRes?.attributePropertyName + ' ' + 'BHK';
    }
    return res;
  }

  redirectMethod(result: any): void {
    if (result.status == "4") {
      this.toast.success('Lead Successfully updated to Dead Lead');
      this.router.navigate(['Leads']);
    } else if (result.status == "5") {
      this.toast.success('Lead Successfully updated to Interested Lead');
      this.router.navigate(['Leads']);
    } else if (result.status == "3") {
      this.toast.success('Lead Successfully updated to Not Interested Lead');
      this.router.navigate(['Leads']);
    } else {
      this.toast.success('Lead Successfully updated to Organized Lead');
      this.router.navigate(['organizedLeads']);
    }
  }

  followupRedirectedMethod(result: any): void {
    const inputDate = new Date(result.date);
    const today = new Date();

    // Normalize both dates to remove time components for accurate comparison
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (inputDate > today) {
      this.router.navigate(['FollowUp']); // Date is in the future
    } else if (inputDate < today) {
      this.router.navigate(['FollowUp']); // Date is in the past
    } else {
      this.router.navigate(['FollowUp']); // Date is today
    }
  }

  toggleRow(index: number) {
    this.rsbService.getFranchiseLogs({ franchiseId: this.lookupModel.getLoggedUser().franchiseId, leadId: this.leads[index].leadId }).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.childData = rsp.contents
        this.expandedIndex = this.expandedIndex === index ? null : index;
      }
    })

  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.typeServices(this.status, this.serviceType)
  }


}


